import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      {/* Single line always. Last item (product name) truncates with "...",
			    and if the trail is still too long on tiny screens it scrolls sideways. */}
      <ol className="flex items-center whitespace-nowrap overflow-x-auto text-xs sm:text-sm [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={item.id || index}
              className={`flex items-center ${isLast ? "min-w-0 flex-1" : "shrink-0"}`}
            >
              {index > 0 && <span className="mx-1.5 text-gray-400">/</span>}
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="text-yellow-800 hover:underline font-medium"
                >
                  {item.name}
                </Link>
              ) : (
                <span
                  title={item.name}
                  className={`truncate ${isLast ? "text-gray-500" : "text-yellow-800 font-medium"}`}
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;